export default {
	client_btn_actions: 'Actions',
	client_btn_activate: 'Activate',
	client_btn_archive: 'Archive',
	client_btn_close: 'Close',
	client_archive_popup_title: 'Client Archival',
	client_archive_popup_text_1: 'Are you sure you wish to archive the client ',
	client_archive_success: 'The client has been successfully archived.',
	client_archive_error_not_exists: 'Client with this ID not found',
	client_archive_error_id_required: 'Client ID not specified',
	client_archive_error_text_1: 'Unable to archive the client!',
	client_archive_error_active_deals_text_1: 'Unable to archive the client! There are active trades on accounts.',
	client_archive_error_active_deals_text_2: 'To proceed with archiving, all client accounts must have no funds in them.',
	client_archive_error_have_money_text_1: 'There are funds remaining on the account.',
	client_archive_error_have_money_text_2: 'To proceed with archiving, all client accounts must have no funds in them.',
	client_activate_popup_text_1: 'Are you sure you want to activate the client ',
	client_activate_popup_title: 'Client activation',
	client_activate_popup_error_text_1: 'Unable to activate client!',
	client_activate_popup_error_uniq_user: 'Telegram IDs are in use by another client.',
	client_activate_popup_success_text: 'The client has been successfully activated.',
	client_info_data_title: 'Client Information',
	client_info_data_id: 'Client ID',
	client_info_data_username: 'Telegram Username',
	client_info_data_first_name: 'Name',
	client_info_data_last_name: 'Surname',
	client_info_data_user_id: 'Telegram client ID',
	client_info_data_phone: 'Phone number',
	client_info_data_email: 'Email',
	client_info_data_linked_to_google: 'Linked to Google',
	client_info_data_linked_to_google_yes: 'Yes',
	client_info_data_linked_to_google_no: 'No',
	client_info_data_created_at: 'Registration Date',
	client_info_data_last_activity: 'Last client activity',
	client_comments_btn_send: 'Send',
	client_comments_text_1: 'Comments',
	client_comments_text_2: 'No comments',
	client_comments_text_3: 'Your message',

	client_accounts_table_title: 'Client Accounts',
	client_accounts_table_id: 'Account',
	client_accounts_table_group: 'Group',
	client_accounts_table_type: 'Type',
	client_accounts_table_balance: 'Balance',
	client_accounts_table_sum_active_deals: 'Sum of Active Deals',
	client_accounts_table_bonus: 'Bonus',
	client_accounts_table_currency: 'Currency',
	client_accounts_table_status: 'Status',

	client_deals_title: 'Deals',
	client_deals_nav_active: 'Active',
	client_deals_nav_history: 'History',

	client_active_deals_table_id: 'ID',
	client_active_deals_table_symbol: 'Symbol',
	client_active_deals_table_amount: 'Amount',
	client_active_deals_table_direction: 'Direction',
	client_active_deals_table_duration: 'Duration',
	client_active_deals_table_strike_price: 'Strike price',
	client_active_deals_table_current_price: 'Current price',
	client_active_deals_table_payout: 'Payout',
	client_active_deals_table_open_time: 'Open time',
	client_active_deals_table_expiry_time: 'Expiry time',
	client_active_deals_table_type: 'Option type',
	client_active_deals_table_result: 'Result',
	client_active_deals_table_group_type: 'Type',
	client_active_deals_table_group_name: 'Group',
	client_active_deals_table_account_id: 'Account',

	client_history_deals_table_id: 'ID',
	client_history_deals_table_symbol: 'Symbol',
	client_history_deals_table_amount: 'Amount',
	client_history_deals_table_direction: 'Direction',
	client_history_deals_table_duration: 'Duration',
	client_history_deals_table_strike_price: 'Strike price',
	client_history_deals_table_expiration_price: 'Expiration price',
	client_history_deals_table_payout: 'Payout',
	client_history_deals_table_open_time: 'Open time',
	client_history_deals_table_expiry_time: 'Expiry time',
	client_history_deals_table_type: 'Option type',
	client_history_deals_table_resolution: 'State',
	client_history_deals_table_comment: 'Comment',
	client_history_deals_table_result: 'Result',
	client_history_deals_table_group_type: 'Type',
	client_history_deals_table_group_name: 'Group',
	client_history_deals_table_account_id: 'Account',

	client_transacyion_history_table_type: 'Type',
	client_transacyion_history_table_payment_system: 'Payment system',
	client_transacyion_history_table_method: 'Method',
	client_transacyion_history_table_amount: 'Amount',
	client_transacyion_history_table_fee: 'Fee',
	client_transacyion_history_table_currency: 'Currency',
	client_transacyion_history_table_amount_credited: 'Transaction amount',
	client_transacyion_history_table_network: 'Network',
	client_transacyion_history_table_address: 'Address',
	client_transacyion_history_table_created_at: 'Date',
	client_transacyion_history_table_status: 'Status',
};
